// Copyright (c) 2026 Riddle, LLC. All rights reserved.
// Author: Ray Harris

export function isEmbeddedFrame(
  target: { readonly self: unknown; readonly top: unknown } = window,
): boolean {
  try {
    return target.self !== target.top;
  } catch {
    return true;
  }
}